Returns transfer groups that may be referenced by public API transfer targets.

<ApiCodeExamples exampleId="transferGroupsList" />

<ApiResponseExamples exampleId="transferGroupsList" />

## Required scope

- `transfer_groups.read`

## Endpoints

- `GET /public/v1/transfer-groups/`: paginated list.
- `GET /public/v1/transfer-groups/{id}/`: detail for one transfer group.

The detail response uses the same field shape as the list item. Members are not returned by default.

## Query parameters

- `page` (`integer`, optional): page number.
- `page_size` (`integer`, optional): items per page. Default `25`, maximum `100`.
- `search` (`string`, optional): searches by group name.
- `ordering` (`string`, optional): `name`, `strategy`, `is_active`, `updated_at`, or the same fields prefixed with `-`.
- `transfer_eligible` (`boolean`, optional): `true` for active groups with at least one eligible member, `false` for groups that cannot receive transfer right now.

## Response fields

- `id` (`uuid`): group public id for `transfer_target.id`.
- `name` (`string`): group name.
- `is_active` (`boolean`): whether the group is active.
- `transfer_eligible` (`boolean`): whether the group has at least one active eligible member endpoint.
- `strategy` (`string`): distribution strategy.
- `eligible_members_count` (`integer`): number of active eligible members.
- `updated_at` (`datetime`): last update time.

## Option reference

- `strategy`: `rrmemory`, `leastrecent`, `fewestcalls`, `ringall`.
- `transfer_eligible=true` requires an active group with at least one active eligible member.

## Expected errors

- `401 Unauthorized`: invalid, expired, revoked, missing, or IP-blocked token.
- `403 Forbidden`: the credential does not have `transfer_groups.read`.
- `404 Not Found`: detail id is not available to the organization.
- `429 Too Many Requests`: credential rate limit exceeded.
